import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from "react-helmet";

const DEFAULT_DESCRIPTION = "Five Metal Shop is a creative studio that designs business. We are located in Hong Kong and Taipei.";
const DEFAULT_IMAGE_URL = "https://fivemetalshop.com/imgs/about/studio__01.jpg";
const DEFAULT_IMAGE_TYPE = "image/jpeg";
const DEFAULT_IMAGE_WIDTH = 1000;
const DEFAULT_IMAGE_HEIGHT = 750;

class BaseMeta extends Component {
  static propTypes = {
    title: PropTypes.string,
    path: PropTypes.string.isRequired,
    description: PropTypes.string,
    imageUrl: PropTypes.string,
    imageType: PropTypes.string,
    imageWidth: PropTypes.number,
    imageHeight: PropTypes.number,
  };

  cutDescription(input) {
    const maxDescriptionLength = 300;
    if (input.length < maxDescriptionLength) {
      return input;
    }

    return input.substr(0, maxDescriptionLength - 1) + '...';
  }

  render() {
    const { title, path, description, imageUrl, imageType, imageWidth, imageHeight, children } = this.props;
    const _title = `fivemetalshop.com${title ? ' - ' + title : ''}`;
    const _description = description != null ? this.cutDescription(description) : DEFAULT_DESCRIPTION;
    const _url = `https://fivemetalshop.com${path}`;
    const _imageUrl = imageUrl != null ? imageUrl : DEFAULT_IMAGE_URL;
    const _imageType = imageType != null ? imageType : DEFAULT_IMAGE_TYPE;
    const _imageWidth = imageWidth ? imageWidth : DEFAULT_IMAGE_WIDTH;
    const _imageHeight = imageHeight ? imageHeight : DEFAULT_IMAGE_HEIGHT;
    const count = React.Children.count(children);

    return (
      <div>
        <Helmet>
          <title>{_title}</title>
          <meta name="description" content={_description} />
          <link rel="canonical" href={_url} />
          <meta property="og:url" content={_url} />
          <meta property="og:title" content={_title} />
          <meta property="og:description" content={_description} />
          <meta property="og:image" content={_imageUrl} />
          <meta property="og:image:type" content={_imageType} />
          <meta property="og:image:width" content={_imageWidth} />
          <meta property="og:image:height" content={_imageHeight} />
          <meta property="og:type" content="website" />
        </Helmet>
        {count === 1
          ? React.Children.only(children)
          : count ? { children } : null
        }
      </div>
    );
  }
}

export default BaseMeta;



// WEBPACK FOOTER //
// ./src/components/base-meta/BaseMeta.js